<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>create</md-icon>
          </div>
          <h4 class="title">メニウくん端末連携</h4>
        </md-card-header>


          <md-card-content class="md-layout formLayout">
          <div class="md-layout md-layout-item md-size-50 md-xsmall-size-100">
            <div class="md-layout-item md-size-100">
              <div>
                <div class="csv-align">
                  <label class="md-form-label" >{{shopTerminalCsv.file_name}}</label>
                  <md-button md-alignment="left" class="md-success md-round md-fileinput">
                    <template>ファイル選択</template>
                    <input type="file" @change="selectedFile" data-id="shopTerminalCsv">
                  </md-button>
                </div>
              </div>
              <ul class="imgAttention">
                <li>ファイル選択後にアップロードファイルを押してください</li>
                <li>完了後にメールが届きます。正しくアップロードされない場合ファイルの修正をしてください</li>
                <li>対応ファイル：csv</li>
                <li>対応エンコード：utf-8</li>
              </ul>
            </div>
          </div>
        </md-card-content>
        <md-card-actions md-alignment="left" class="mt60 mx-auto">
          <md-button class="md-success md-lg" @click.native="uploadCsv('shopTerminalCsv')">アップロード</md-button>
        </md-card-actions>
      </md-card>
    </div>

    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>create</md-icon>
          </div>
          <h4 class="title">決済端末連携</h4>
        </md-card-header>


          <md-card-content class="md-layout formLayout">
          <div class="md-layout md-layout-item md-size-50 md-xsmall-size-100">
            <div class="md-layout-item md-size-100">
              <div>
                <div class="csv-align">
                  <label class="md-form-label" >{{paymentTerminalCsv.file_name}}</label>
                  <md-button md-alignment="left" class="md-success md-round md-fileinput">
                    <template>ファイル選択</template>
                    <input type="file" @change="selectedFile" data-id="paymentTerminalCsv">
                  </md-button>
                </div>
              </div>
              <ul class="imgAttention">
                <li>ファイル選択後にアップロードファイルを押してください</li>
                <li>完了後にメールが届きます。正しくアップロードされない場合ファイルの修正をしてください</li>
                <li>対応ファイル：csv</li>
                <li>対応エンコード：utf-8</li>
              </ul>
            </div>
          </div>
        </md-card-content>
        <md-card-actions md-alignment="left" class="mt60 mx-auto">
          <md-button class="md-success md-lg" @click.native="uploadCsv('paymentTerminalCsv')">アップロード</md-button>
        </md-card-actions>
      </md-card>
    </div>

    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>create</md-icon>
          </div>
          <h4 class="title">店舗カード連携</h4>
        </md-card-header>


          <md-card-content class="md-layout formLayout">
          <div class="md-layout md-layout-item md-size-50 md-xsmall-size-100">
            <div class="md-layout-item md-size-100">
              <div>
                <div class="csv-align">
                  <label class="md-form-label" >{{shopCardCsv.file_name}}</label>
                  <md-button md-alignment="left" class="md-success md-round md-fileinput">
                    <template>ファイル選択</template>
                    <input type="file" @change="selectedFile" data-id="shopCardCsv">
                  </md-button>
                </div>
              </div>
              <ul class="imgAttention">
                <li>ファイル選択後にアップロードファイルを押してください</li>
                <li>完了後にメールが届きます。正しくアップロードされない場合ファイルの修正をしてください</li>
                <li>対応ファイル：csv</li>
                <li>対応エンコード：utf-8</li>
              </ul>
            </div>
          </div>
        </md-card-content>
        <md-card-actions md-alignment="left" class="mt60 mx-auto">
          <md-button class="md-success md-lg" @click.native="uploadCsv('shopCardCsv')">アップロード</md-button>
        </md-card-actions>
      </md-card>

    </div>   
  </div>

</template>

<script>
  import router from '../packs/router.js'
  import role from "../mixins/role.js"

  export default {
    mixins: [ role ],
    components: {
    },
    computed: {
    },
    props: {
      
    },
    data () {
      return {
        shopTerminalCsv: {
          path: '/shop_terminals/',
          file: '',
          file_name: ''
        },
        paymentTerminalCsv: {
          path: '/payment_terminals/',
          file: '',
          file_name: ''
        },
        shopCardCsv: {
          path: '/shop_cards/',
          file: '',
          file_name: ''
        },
      }
    },
    methods: {
      selectedFile(e){
        e.preventDefault();
        let files = e.target.files;
        let data_id = e.currentTarget.getAttribute('data-id');
        this[data_id].file = files[0];
        this[data_id].file_name = files[0].name;
      },
      validate() {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.updateService()
          } else {
            this.validateError()
          }
        })
      },
      uploadCsv(csv_conf){
        let formData = new FormData();
        if(this[csv_conf].file === ''){
          this.dangerNotify("CSVファイルを選択してください")
          return 
        }
        formData.append('file', this[csv_conf].file);
        this.axios({
          method  : 'POST',
          url     : this.AdminApiUrl + this[csv_conf].path + '/import_csv/',
          timeout : 30000,
          data: formData,
          headers : {'content-type': 'multipart/form-data' , 'Authorization': this.$Cookies.get('accessToken')}
        }).then(response => {
          this.successAndBackPage("CSVのアップロードが完了しました")
          this[csv_conf].file == ''
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.tokenError()
          } else {
            this.dangerNotify("CSVのアップロードが失敗しました")
          }
        })
      }
    },
    mounted () {
      if (!this.superFlag) {
        router.push({ path: '/admin/login'})
        return false
      }
    },
    watch: {
      
    }
  }
</script>

<style lang="css" scoped>
.md-card .md-card-actions{
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

.fade-enter-active, .fade-leave-active {
  will-change: opacity;
  transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}
.fade-enter, .fade-leave-to {
  opacity: 0
}

.btnCenter{
  margin-left: auto !important;
  margin-right: auto !important;
}

.formLayout{
  flex-basis: auto;
}

.labels{
  color: #666666;
  font-weight: 400;
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
  padding-bottom: 10px;
}

.imageWidth{
  width: 100%;
  max-width: 300px;
  display: block;
  margin: 0 auto
}

.csv-align {
  align-items: left;
}

.image-container{
  max-width: none;
}



.BtnAdd,
.BtnRemove{
  color: #666666;
  padding: 3px 0;
  line-height: 24px;
  cursor: pointer;
}


.md-layout-item.md-size-walk{
  min-width: 33%;
  max-width: 33%;
  flex: 0 1 33%;
}

.w200{
  width: 200px;
}

.imgAttention{
  font-size: 12px;
  color: #333333;
  padding-left: 10px;
  list-style: none;
}

.imgAttention li{
  padding-left: 10px;
  position: relative;
  line-height: 18px;
}

.imgAttention li:before{
  content: '*';
  position: absolute;
  top: 0;
  left: 0;
}

@media screen and (max-width:600px) {
  .md-card .md-card-content .md-form-label{
    text-align: left;
  }

  .md-layout-item.md-size-walk{
    min-width: 100%;
    max-width: 100%;
    flex: 0 1 100%;
  }

  .is-xs-none{
    display: none;
  }

  .is-xs-block{
    display: block;
  }

  .imageWidth{
    width: auto;
  }

  .imageWalk{
    width: auto
  }

  .image-container{
    margin: 0 auto 10px;
  }
}

</style>
